var i = function(n, e) {
  return n.indexOf(e) !== -1;
};
export {
  i
};
